import * as PurchaseOrderTypes from './constants';

const defaultParams = {
  searchKey: '',
  skip: 0,
  take: 10,
  sort: { field: 'refNo', order: 'descending' },
  totalRecord: 0,
  totalPage: 0
};

const initialState = {
  ManagePurchaseOrder: {
    items: [],
    params: defaultParams
  },
  PurchaseOrderProfile: {}
};

export default function WorkOrderStore(state = initialState, action) {

  switch (action.type) {
    case PurchaseOrderTypes.GET_PURCHASE_ORDER_LIST_SUCCESS:
      return processGetPurchaseOrdersList(state, action);

    case PurchaseOrderTypes.GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_SUCCESS:
      return processGetSubcontractorPurchaseOrdersDetail(state, action);

    case PurchaseOrderTypes.EDIT_PURCHASE_ORDER_SUCCESS:
    case PurchaseOrderTypes.GET_PURCHASE_ORDER_DETAIL_SUCCESS:
      return {
        ...state,
        PurchaseOrderProfile: action.data
      };

    case PurchaseOrderTypes.GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_ASYNC:
    case PurchaseOrderTypes.GET_PURCHASE_ORDER_DETAIL_FAIL:
      return {
        ...state,
        PurchaseOrderProfile: {}
      };

    default:
      return state;

  }
}

const processGetPurchaseOrdersList = (state, action) => {
  const {data} = action;
  return {
    ...state,
    ManagePurchaseOrder: {
      items: data.data.items,
      params: {
        ...data.params,
        sort: { field: data.sortField, order: data.sortOrder },
        totalPage: data.data.totalPage,
        totalRecord: data.data.totalRecord
      }
    }

  };
};

const processGetSubcontractorPurchaseOrdersDetail = (state, action) => {
  const {data} = action;
  return {
    ...state,
    PurchaseOrderProfile: {
      ...data.purchaseOrder,
      builderProfile: data.builderProfile
    }

  };
};




// WEBPACK FOOTER //
// ./src/Purchase-Orders/reducers.js